var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pw-tab-strip",class:{
    'pw-tab-strip--is-vertical': _vm.isVertical,
    'pw-tab-strip--pill-mode': _vm.pillMode,
  }},[_c('div',{staticClass:"pw-tab-strip__header"},[_c('ul',{staticClass:"tab-strip__items"},_vm._l((_vm.tabItems),function(item,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(item.visible),expression:"item.visible"}],key:index,class:{
          'tab-strip__row': true,
          'is-active': _vm.activeTab === index,
          'is-disabled': item.disabled,
          'is-filled': item.filled,
          ..._vm.classColorActive,
          ...item.customClass,
        },on:{"click":function($event){return _vm.tabClick(index)}}},[(!_vm.$slots.title)?_c('span',[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e(),_vm._t("title")],2)}),0)]),_c('div',{staticClass:"pw-tab-strip__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }